import { Link } from 'react-router-dom';

const NewsSection = () => {
  const newsItems = [
    {
      date: '2025.01.15',
      category: 'お知らせ',
      title: '年末年始の診療時間のお知らせ',
      description: '2025年12月29日から2026年1月3日まで休診とさせていただきます。',
    },
    {
      date: '2025.01.10',
      category: '診療情報',
      title: '新しいリハビリテーション機器を導入しました',
      description: '最新の物理療法機器により、より効果的な治療が可能になりました。',
    },
    {
      date: '2025.01.05',
      category: 'イベント',
      title: '健康セミナー開催のご案内',
      description: '腰痛予防をテーマとした無料セミナーを2月に開催いたします。',
    },
  ];

  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-blue-50/50 to-white px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left: Title */}
          <div className="lg:col-span-3">
            <span className="text-[#007bbb] text-xs font-semibold tracking-widest uppercase">NEWS</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mt-4 leading-tight">
              お知らせ<br />
              <span className="text-2xl md:text-3xl lg:text-4xl">新着情報</span>
            </h2>
          </div>

          {/* Right: News Cards */}
          <div className="lg:col-span-9 space-y-4">
            {newsItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow p-6 lg:p-8 flex flex-col md:flex-row gap-6"
              >
                {/* Date Badge */}
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 bg-[#007bbb] rounded-xl flex items-center justify-center">
                    <span className="text-white text-sm font-bold text-center leading-tight">
                      {item.date.split('.')[1]}.{item.date.split('.')[2]}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <span className="inline-block bg-[#007bbb]/10 text-[#007bbb] text-xs font-medium px-3 py-1 rounded-full mb-3">
                    {item.category}
                  </span>
                  <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm md:text-base">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}

            {/* View All Link */}
            <div className="text-right pt-4">
              <Link
                to="/news"
                className="inline-flex items-center text-[#007bbb] font-medium hover:text-[#006399] transition-colors"
              >
                すべてのお知らせを見る
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
